import { format } from "date-fns";

type LogLevel = "info" | "warn" | "error" | "debug" | "success";

/**
 * Standardized Logger Utility
 * Formats logs as: [TIMESTAMP] [LEVEL] [CONTEXT] Message
 */
export class Logger {
  private static getTimestamp(): string {
    return format(new Date(), "yyyy-MM-dd HH:mm:ss");
  }

  private static formatMessage(level: LogLevel, context: string, message: any): string[] {
    const timestamp = this.getTimestamp();
    const prefix = `[${timestamp}] [${level.toUpperCase()}] [${context}]`;
    return [prefix, message];
  }

  static info(context: string, message: any, ...args: any[]) {
    console.log(...this.formatMessage("info", context, message), ...args);
  }

  static warn(context: string, message: any, ...args: any[]) {
    console.warn(...this.formatMessage("warn", context, message), ...args);
  }

  static error(context: string, message: any, ...args: any[]) {
    console.error(...this.formatMessage("error", context, message), ...args);
  }

  static debug(context: string, message: any, ...args: any[]) {
    if (process.env.NODE_ENV === "development") {
      console.debug(...this.formatMessage("debug", context, message), ...args);
    }
  }

  static success(context: string, message: any, ...args: any[]) {
    // Using console.log but with a specialized tag if needed, or colored output in node
    console.log(...this.formatMessage("success", context, message), ...args);
  }
}
